export const buildMultipleKeyForArrayParams = (key: string, values: string[]) =>
  values.map((value) => `${key}=${value}`).join('&');
